const toastErrors = {
  'fleet-task-route-optimization-invalid-break-time': 'routeOptimization.alert.breakTimeSameDay',
  'fleet-task-route-optimization-start-break-time-greater-than-end-break-time':
    'routeOptimization.alert.breakEndTimeInvalid',
  'fleet-task-route-optimization-vendor-platform-invalid-lat-lng':
    'routeOptimization.alert.invalidAddress',
  'fleet-task-route-optimization-limit-reached': 'routeOptimization.alert.limitReached',
  'fleet-task-route-optimization-empty-order': 'routeOptimization.alert.emptyOrder',
  'fleet-task-route-optimization-delivery-order-user-group-id-required':
    'routeOptimization.alert.deliveryOrderUserGroupRequired',
  'fleet-task-route-optimization-delivery-order-user-group-id-different':
    'routeOptimization.alert.deliveryOrderUserGroupDifferent',
  'fleet-task-route-optimization-vehicle-unassigned': 'routeOptimization.alert.vehicleUnassigned',
  'fleet-task-delivery-order-invalid-status':
    'routeOptimization.alert.fleetTaskDeliveryOrderInvalidStatus',
  'fleet-task-route-optimization-vehicle-already-assigned':
    'routeOptimization.alert.vehicleAlreadyAssigned',
  'fleet-task-route-optimization-invalid-status':
    'routeOptimization.alert.routeOptimizationInvalidStatus',
  'fleet-task-delivery-order-product-category-id-different':
    'routeOptimization.alert.deliveryOrderProductCategoryMismatch',
  'fleet-task-delivery-order-product-category-more-than-one':
    'routeOptimization.alert.deliveryOrderProductCategoryMoreThanOne',
  'fleet-task-route-optimization-invalid-single-pickup':
    'routeOptimization.alert.routeOptimizationInvalidSinglePickup',
}

export default toastErrors
